import { action, createRequestTypes } from './base';

export const reportActionTypes = {
  GET_REPORTS: createRequestTypes('GET_REPORTS'),
  GET_PRODUCTION_REPORTS: createRequestTypes('GET_PRODUCTION_REPORTS'),
  GET_DOWNLOAD_REPORTS: createRequestTypes('GET_DOWNLOAD_REPORTS'),
  GET_STOCK_AGEING_REPORTS: createRequestTypes('GET_STOCK_AGEING_REPORTS'),
};

/**
 *
 */
class ReportActions {
  /**
   * @param orgId
   * @param tenantIds
   * @param fromDate
   * @param toDate
   * @param firstSubUrl
   * @param secondSubUrl
   * @param reportType
   * @param sellerId
   * @return
   */
  getReports = (firstSubUrl, secondSubUrl, orgId, tenantIds, fromDate, toDate, reportType, page, limit, departmentId, sellerId, costingMethod, customerId, category) => action(reportActionTypes.GET_REPORTS.REQUEST, {
    firstSubUrl, secondSubUrl, orgId, tenantIds, fromDate, toDate, reportType, page, limit, departmentId, sellerId, costingMethod, customerId, category,
  })

  /**
   *
   * @param {*} getReportsLoading
   * @return
   */
  getReportsLoading = (getReportsLoading) => action(reportActionTypes.GET_REPORTS.LOADING, {
    getReportsLoading,
  })

  /**
     *
     * @param {*} reportData
     * @return
     */
  getReportsSuccess = (reportData) => action(reportActionTypes.GET_REPORTS.SUCCESS, {
    reportData,
  })

  /**
   *
   * @param {*} getProductionReports
   * @return
   */
  getProductionReports = (tenantIds, fromDate, toDate, page, limit, departmentId, moType, status, category) => action(reportActionTypes.GET_PRODUCTION_REPORTS.REQUEST, {
    tenantIds, fromDate, toDate, page, limit, departmentId, moType, status, category
  })

  /**
   *
   * @param {*} getReportsLoading
   * @return
   */
  getProductionReportsLoading = (getProductionReportsLoading) => action(reportActionTypes.GET_PRODUCTION_REPORTS.LOADING, {
    getProductionReportsLoading,
  })

  /**
     *
     * @param {*} reportData
     * @return
   */
  getProductionReportsSuccess = (productionReportData) => action(reportActionTypes.GET_PRODUCTION_REPORTS.SUCCESS, {
    productionReportData,
  })

  /**
  *
  * @param {*} getStockAgeingReports
  * @return
  */
  getStockAgeingReports = (tenantIds, method, interval, steps, date, departmentId, currentPage, limit, category) => action(reportActionTypes.GET_STOCK_AGEING_REPORTS.REQUEST, {
    tenantIds, method, interval, steps, date, departmentId, currentPage, limit, category
  })

  /**
   *
   * @param {*} getStockAgeingReportsLoading
   * @return
   */
  getStockAgeingReportsLoading = (getStockAgeingReportsLoading) => action(reportActionTypes.GET_STOCK_AGEING_REPORTS.LOADING, {
    getStockAgeingReportsLoading,
  })

  /**
     *
     * @param {*} reportData
     * @return
   */
  getStockAgeingSuccess = (StockAgeingReportData) => action(reportActionTypes.GET_STOCK_AGEING_REPORTS.SUCCESS, {
    StockAgeingReportData,
  })

  /**
  * @param {*} firstSubUrl
  * @param {*} secondSubUrl
  * @param {*} orgId
  * @param {*} tenantIds
  * @param {*} fromDate
  * @param {*} toDate
  * @param fileReportType
  * @param reportName
  * @param {*} type
  * @param {*} sellerId
  * @return
  */
  getDownloadReports = (firstSubUrl, secondSubUrl, orgId, tenantIds, fromDate, toDate, fileReportType, reportName, sellerId, departmentId, moType, status, emails, noWait, intervals, noOfColumns, selectedMethod, selectedDate, costingMethod, customerId, category, callback) => action(reportActionTypes.GET_DOWNLOAD_REPORTS.REQUEST, {
    firstSubUrl, secondSubUrl, orgId, tenantIds, fromDate, toDate, fileReportType, reportName, sellerId, departmentId, moType, status, emails, noWait, intervals, noOfColumns, selectedMethod, selectedDate, costingMethod, customerId, category, callback,
  })

  /**
   *
   * @param {*} getDownloadReportsLoading
   * @return
   */
  getDownloadReportsLoading = (getDownloadReportsLoading) => action(reportActionTypes.GET_DOWNLOAD_REPORTS.LOADING, {
    getDownloadReportsLoading,
  })

  /**
   *
   * @param {*} downloadReportsData
   * @return
   */
  getDownloadReportsSuccess = (downloadReportsData) => action(reportActionTypes.GET_DOWNLOAD_REPORTS.SUCCESS, {
    downloadReportsData,
  })
}

export default new ReportActions();
